import { useTheme } from 'contexts/ThemeContext';
import { Control, Controller } from 'react-hook-form';
import { ThemeType } from 'styles/colorMode';

import {
    ProfileDropdownOption,
    ProfileItem,
    ProfileSettingDropdown,
    ProfileSubSection,
} from '../components';
import { UserSettingsFormData } from './UserProfileModal';

const themeOptions: ProfileDropdownOption<ThemeType>[] = [
    { Value: ThemeType.light, Text: 'Light' },
    { Value: ThemeType.dark, Text: 'Dark' },
    { Value: ThemeType.night, Text: 'Night' },
];

export type AppearanceOption = 'theme';

type Props = Readonly<{
    control: Control<UserSettingsFormData>;
    allowedFeatures: Set<AppearanceOption>;
}>;

export function AppearanceSubSection({ control, allowedFeatures }: Props) {
    const { setColorMode } = useTheme();

    if (allowedFeatures.size === 0) {
        return null;
    }

    return (
        <ProfileSubSection title="Appearance">
            {allowedFeatures.has('theme') && (
                <ProfileItem label="Color Theme">
                    <Controller
                        control={control}
                        name="colorMode"
                        render={({ field: { onChange, value } }) => (
                            <ProfileSettingDropdown
                                options={themeOptions}
                                value={
                                    themeOptions.find((o) => o.Value === value) ??
                                    themeOptions[0]
                                }
                                onConfirm={(value) => {
                                    if (value) {
                                        // set a preview for the user to see via `transient`
                                        // true saving happens later
                                        setColorMode(value.Value, {
                                            transient: true,
                                        });
                                        onChange(value.Value);
                                    }
                                }}
                            />
                        )}
                    />
                </ProfileItem>
            )}
        </ProfileSubSection>
    );
}
